import React from 'react'
import {
  Divider,
  Grid,
  ListItem,
  Typography,
  withStyles,
} from '@material-ui/core'
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer'
import themeCreateInjectableStyles from 'Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support'
import { WithGlobalStylesProps } from 'types/styles/WithGlobalStylesProps'
import { compose } from 'recompose'
import cn from 'classnames'
import ActivityLogModalStyles from '../ActivityLogModal.styles'
import { withGlobalStyles } from 'Support/Theme/CreateInjectableStyles/withGlobalStyles'

interface Props {
  primaryText: string,
  subText: string,
  dateText?: string,
}
type FProp = Props & WithGlobalStylesProps<any>

const ActivityLogItemComp = (props: FProp) => {
  const {
    primaryText,
    subText,
    dateText = '',
    classes,
  } = props
  return (
    <React.Fragment>
      <ListItem className={cn(classes.listItemRoot)} disableGutters>
        <Grid alignItems='center' container>
          <Grid item xs={12}>
            <Grid alignItems='center' container>
              <Grid className={cn(classes.flexGrow1)} item>
                <Typography color='textPrimary' component='span' variant='body2'>
                  { primaryText }
                </Typography>
              </Grid>
              <Grid item>
                <Typography className={cn(classes.activityDate)} color='textSecondary' component='span' variant='caption'>
                  { dateText }
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid className={cn(classes.flexGrow1)} item xs={12}>
            <Grid className={cn(classes.flexGrow1)} item xs={12}>
              <Typography className={cn(classes.activityDescription)} color='textSecondary' component='span' variant='caption' data-mf-replace-inner={MFSDR}>
                { subText }
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </ListItem>
      <Divider />
    </React.Fragment>
  )
}

export default compose<FProp, Props>(
  withGlobalStyles(ActivityLogModalStyles),
)(ActivityLogItemComp)
